import { render } from "./loader.vue?vue&type=template&id=9e2011de&scoped=true"
import script from "./loader.vue?vue&type=script&lang=js"
export * from "./loader.vue?vue&type=script&lang=js"

import "./loader.vue?vue&type=style&index=0&id=9e2011de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e2011de"]])

export default __exports__